const temaDark = {
  corPrincipal: '#fff',
  corSecundaria: '#eee',
  corDeFundo: '#282a35',
  corDeFundoBotao: '#fff',
  corDaBorda: '#c1c1c1'
};

export default temaDark;

// Criado para satisfazer o DefaultTheme como o Casting
export type Theme = {
  corPrincipal: string;
  corSecundaria: string;
  corDeFundo: string;
  corDeFundoBotao: string;
  corDaBorda: string;
};
